import { Routes } from '@angular/router';

import { routeData } from '@frontend/vanilla/core';

import { myaccountProductActivateGuard, myaccountProductDeactivateGuard } from './myaccount.gaurd';
import { TagManagerRendererService } from './services/tagmanager-renderer.service';

export const INTERNAL_MY_ACCOUNT_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '{culture}',
    },
    {
        path: 'home',
        redirectTo: '{culture}',
    },
    // INTERCEPTORS START
    {
        path: 'accountstatus',
        loadChildren: () => import('./account-status/account-status.routes').then((m) => m.accountStatusRoutes),
    },
    {
        path: 'egamesngverification',
        loadChildren: () => import('./interceptors/egames-ng-verification/egames-ng-verification.routes').then((m) => m.eGamesNgVerificationRoutes),
    },
    {
        path: 'incorrectnrn',
        loadChildren: () => import('./interceptors/incorrect-nrn/incorrect-nrn-routes').then((m) => m.incorrectNrnRoutes),
    },
    {
        path: 'rgtest',
        loadChildren: () => import('./interceptors/rg-test/rg-test.routes').then((m) => m.rgTestRoutes),
    },
    {
        path: 'strongauth',
        loadChildren: () => import('./interceptors/strong-auth/strong-auth.routes').then((m) => m.strongAuthRoutes),
    },
    {
        path: 'affordability',
        loadChildren: () => import('./interceptors/affordability/affordability-routes').then((m) => m.AffordabilityRoutes),
    },
    {
        path: 'aff',
        loadChildren: () => import('./interceptors/affordability/affordability-routes').then((m) => m.AffordabilityRoutes),
    },
    {
        path: 'strongauthv2',
        loadChildren: () => import('./interceptors/strong-authv2/strong-authv2.routes').then((m) => m.strongAuthV2Routes),
    },
    {
        path: 'singleaccount',
        loadChildren: () => import('./interceptors/single-account/single-account.routes').then((m) => m.singleAccountRoutes),
    },
    {
        path: 'postloginkycinfo',
        loadChildren: () => import('./interceptors/post-login-kyc-info/post-login-kyc-info.routes').then((m) => m.PostLoginKycInfoRoutes),
    },
    {
        path: 'chooseproduct',
        loadChildren: () =>
            import('./interceptors/belgium-multi-selection/belgium-multi-selection.routes').then((m) => m.BelgiumMultiSelectionRoutes),
    },
    {
        path: 'accountTransfer',
        loadChildren: () => import('./interceptors/account-transfer/account-transfer.routes').then((m) => m.AccountTransferRoutes),
    },
    {
        path: 'sqsalogin',
        loadChildren: () => import('./interceptors/sqsa-login/sqsa-login.routes').then((m) => m.sqsaLoginRoutes),
    },
    {
        path: 'dobssnlogin',
        loadChildren: () => import('./interceptors/dob-ssn-login/dob-ssn-login.routes').then((m) => m.dobssnLoginRoutes),
    },
    {
        path: 'depositlimitsconfirmation',
        loadChildren: () =>
            import('./interceptors/deposit-limit-confirmation/deposit-limit-confirmation.routes').then((m) => m.depositLimitConfirmationRoutes),
    },
    {
        path: 'depositlimitincrementconfirmation',
        loadChildren: () =>
            import('./interceptors/deposit-limit-increment-confirmation/deposit-limit-increment-confirmation.routes').then(
                (m) => m.depositLimitIncrementConfirmationRoutes,
            ),
    },
    {
        path: 'fundsregulation',
        loadChildren: () => import('./interceptors/funds-regulation/funds-regulation.routes').then((m) => m.fundsRegulationRoutes),
    },
    {
        path: 'fundtransfer',
        loadChildren: () => import('./interceptors/fund-transfer/fund-transfer-routes').then((m) => m.FundTransferRoutes),
    },
    {
        path: 'graceperiod',
        loadChildren: () => import('./interceptors/grace-period/grace-period.routes').then((m) => m.gracePeriodRoutes),
    },
    {
        path: 'realitycheckpreferences',
        loadChildren: () =>
            import('./interceptors/reality-check-preferences/reality-check-preferences-routes').then((m) => m.realityCheckPreferencesRoutes),
    },
    {
        path: 'premiummigration',
        loadChildren: () => import('./interceptors/premium-migration/premium-migration.routes').then((m) => m.premiumMigrationRoutes),
    },
    {
        path: 'intramigratedinfo',
        loadChildren: () => import('./interceptors/intra-migrated-info/intra-migrated-info.routes').then((m) => m.intraMigratedInfoRoutes),
    },
    {
        path: 'communicationpreference',
        loadChildren: () =>
            import('./interceptors/communication-preference/communication-preference.routes').then((m) => m.communicationpreferenceRoutes),
    },
    {
        path: 'nationality',
        loadChildren: () => import('./interceptors/nationality/nationality.routes').then((m) => m.nationalityRoutes),
    },
    {
        path: 'screenname',
        loadChildren: () => import('./interceptors/screen-name/screen-name.routes').then((m) => m.screenNameRoutes),
    },
    {
        path: 'tnc',
        loadChildren: () => import('./interceptors/terms-and-conditions/terms-and-conditions.routes').then((m) => m.tncRoutes),
    },
    {
        path: 'useracknowledgement',
        loadChildren: () => import('./interceptors/user-acknowledgement/user-acknowledgement.routes').then((m) => m.userAcknowledgementRoutes),
    },
    {
        path: 'rg',
        loadChildren: () => import('./rg-limits/rg-limits-confirmation.routes').then((m) => m.rgLimitsRoutes),
    },
    {
        path: 'twofa',
        loadChildren: () => import('./interceptors/two-fa/two-fa-routes').then((m) => m.twoFaRoutes),
    },
    {
        path: 'duplicateemail',
        loadChildren: () => import('./interceptors/duplicate-email/duplicate-email.routes').then((m) => m.duplicateEmailRoutes),
    },
    {
        path: 'gamstoprgcheck',
        loadChildren: () => import('./interceptors/gam-stop-rg-check/gam-stop-rg-check.routes').then((m) => m.gamStopRgCheckRoutes),
    },
    {
        path: 'jumiokyc',
        loadChildren: () => import('./interceptors/jumio-kyc/jumio-kyc-main-routes').then((m) => m.jumioRoutes),
    },
    {
        path: 'aamsverification',
        loadChildren: () => import('./interceptors/bio-data-it/bio-data-it.routes').then((m) => m.bioDataItRoutes),
    },
    {
        path: 'addresspinverification',
        loadChildren: () =>
            import('./interceptors/address-pin-verification/address-pin-verification.routes').then((m) => m.addressPinVerificationRoutes),
    },
    {
        path: 'playerlimits',
        loadChildren: () => import('./interceptors/player-limits/player-limits.routes').then((m) => m.playerLimitsRoutes),
    },
    {
        path: 'addresscodeverification',
        loadChildren: () => import('./interceptors/address-verification/address-verification.routes').then((m) => m.addressVerificationRoutes),
    },
    {
        path: 'migrationconsent',
        loadChildren: () =>
            import('./interceptors/cashcade-migration-consent/cashcade-migration-consent.routes').then((m) => m.cashcadeMigrationConsentRoutes),
    },
    {
        path: 'logout',
        loadChildren: () => import('./logout/logout.routes').then((m) => m.logoutRoutes),
    },
    {
        path: 'setloginlimits',
        loadChildren: () =>
            import('./interceptors/login-timemanagement/login-timemanagement-routes').then((m) => m.loginTimeManagementInterceptorRoutes),
    },
    {
        path: 'exitconfirmation',
        loadChildren: () => import('./interceptors/exit-confirmation/exit-confirmation.routes').then((m) => m.exitConfirmationRoutes),
    },
    {
        path: 'docuploadstatuscheck',
        loadChildren: () => import('./interceptors/docupload-status-check/docupload-status-check.routes').then((m) => m.docUploadStatusCheckRoutes),
    },
    {
        path: 'manualdocuploadstatus',
        loadChildren: () =>
            import('./interceptors/manual-docupload-status-check/manual-docupload-status-check.routes').then(
                (m) => m.manualDocUploadStatusCheckRoutes,
            ),
    },
    {
        path: 'dormantaccount',
        loadChildren: () => import('./manual-doc-upload-revamp/manual-doc-upload-revamp.routes').then((m) => m.manualDocUploadRevampRoutes),
    },
    {
        path: 'ukgckyc',
        loadChildren: () => import('./interceptors/ukgc-kyc/ukgc-kyc.routes').then((m) => m.ukgcKycRoutes),
    },
    {
        path: 'deannualrekyc',
        loadChildren: () => import('./interceptors/ukgc-kyc/ukgc-kyc.routes').then((m) => m.ukgcKycRoutes),
    },
    {
        path: 'additionaldetails',
        loadChildren: () => import('./interceptors/additional-info/additional-info-routes').then((m) => m.additionalInfoRoutes),
    },
    {
        path: 'schufa',
        loadChildren: () => import('./interceptors/ukgc-kyc/ukgc-kyc.routes').then((m) => m.ukgcKycRoutes),
    },
    {
        path: 'dekyc',
        loadChildren: () => import('./interceptors/de-kyc/de-kyc.routes').then((m) => m.dekycRoutes),
    },
    {
        path: 'defullkyc',
        loadChildren: () => import('./interceptors/ukgc-kyc/ukgc-kyc.routes').then((m) => m.ukgcKycRoutes),
    },
    {
        path: 'kyc',
        loadChildren: () => import('./interceptors/ukgc-kyc/ukgc-kyc.routes').then((m) => m.ukgcKycRoutes),
    },
    {
        path: 'rcpu',
        loadChildren: () => import('./interceptors/rcpu/rcpu.routes').then((m) => m.rcpuRoutes),
    },
    {
        path: 'password',
        loadChildren: () => import('./interceptors/password-interceptor/password-interceptor-routes').then((m) => m.PasswordInterceptorRoutes),
    },
    {
        path: 'sourceoffunds',
        loadChildren: () => import('./interceptors/source-of-funds/source-of-funds-routes').then((m) => m.sourceOfFundsRoutes),
    },
    {
        path: 'weeklydepositlimits',
        loadChildren: () => import('./interceptors/weekly-deposit-limits/weekly-deposit-limits-routes').then((m) => m.weeklyDepositLimitsRoutes),
    },
    {
        path: 'setlimits',
        loadChildren: () =>
            import('./interceptors/account-limit-interceptor/account-limit-interceptor-routes').then((m) => m.accountLimitInterceptorRoutes),
    },
    {
        path: 'personaldetailscheck',
        loadChildren: () => import('./interceptors/personal-details-check/personal-details-check-routes').then((m) => m.personalDetailsCheckRoutes),
    },
    {
        path: 'personaldetails',
        loadChildren: () =>
            import('./interceptors/personal-details-interceptor/personal-details-interceptor-routes').then((m) => m.personalDetailsInterceptorRoutes),
    },
    {
        path: 'loginlimits',
        loadChildren: () => import('./interceptors/login-limits/login-limits.routes').then((m) => m.loginLimitsRoutes),
    },
    {
        path: 'expiredcoolofftimeconfirmation',
        loadChildren: () =>
            import('./interceptors/expired-cool-off-time-confirmation/expired-cool-off-time.routes').then((m) => m.expiredCooloffTimeRoutes),
    },
    {
        path: 'arc',
        loadChildren: () => import('./interceptors/arc/arc-routes').then((m) => m.arcRoutes),
    },
    {
        path: 'arcint',
        loadChildren: () => import('./interceptors/arc-international/arc-international-routes').then((m) => m.arcRoutes),
    },
    {
        path: 'fittoplay',
        loadChildren: () => import('./interceptors/fit-to-play/fit-to-play-routes').then((m) => m.FitToPlayRoutes),
    },
    {
        path: 'okto',
        loadChildren: () => import('./interceptors/okto/okto-routes').then((m) => m.OktoRoutes),
    },
    {
        path: 'nevdocuploader',
        loadChildren: () => import('./interceptors/nev-document-uploader/nev-document-uploader.routes').then((m) => m.nevdocumentUploaderRoutes),
    },
    {
        path: 'privacypolicy',
        loadChildren: () => import('./interceptors/privacy-policy-interceptor/privacy-policy-interceptor.routes').then((m) => m.privacyPolicyRoutes),
    },
    {
        path: 'iban',
        loadChildren: () => import('./interceptors/iban/iban.routes').then((m) => m.ibanRoutes),
    },
    {
        path: 'verifycontact',
        loadChildren: () => import('./interceptors/contact-verification/contact-verification.routes').then((m) => m.contactVerificationRoutes),
    },
    {
        path: 'info/:type',
        loadChildren: () => import('./interceptors/interceptor-message/interceptor-message.routes').then((m) => m.infoRoutes),
    },
    {
        path: 'risksuspiciousplayer',
        loadChildren: () => import('./interceptors/risk-suspicious-player/risk-suspicious-player.routes').then((m) => m.riskSuspiciousPlayerRoutes),
    },
    {
        path: 'emailverification',
        loadChildren: () => import('./interceptors/email-verification/email-id-verification.routes').then((m) => m.emailVerificationRoutes),
    },
    {
        path: 'loginlimitssetup',
        loadChildren: () =>
            import('./interceptors/poland-login-limits-confirmation/limits-set-up-confirmation.routes').then((m) => m.polandLimitsSetUpRoutes),
    },
    {
        path: 'monthlyreminder',
        loadChildren: () => import('./interceptors/monthly-reminder/monthly-reminder.routes').then((m) => m.monthlyReminderRoutes),
    },
    // INTERCEPTORS END
    {
        path: 'jumiocallback',
        loadChildren: () => import('./jumio-callback/jumio-callback-routes').then((m) => m.jumioCallbackRoutes),
    },
    {
        path: 'contact',
        loadChildren: () => import('./contact/contact-routes').then((m) => m.contactRoutes),
    },
    {
        path: 'feedback',
        loadChildren: () => import('./feedback/feedback-routes').then((m) => m.feedbackRoutes),
    },
    {
        path: 'register',
        loadChildren: () => import('./registration/registration.routes').then((m) => m.registrationRoutes),
    },
    {
        path: 'ds',
        loadChildren: () => import('./common/ds-iframe/ds-iframe-routes').then((m) => m.dsIframeRoutes),
    },
    {
        path: 'paypal',
        loadChildren: () => import('./register-with-paypal/register-with-paypal.routes').then((m) => m.registerWithPaypalRoutes),
    },
    {
        path: 'details',
        loadChildren: () => import('./personal-details/personal-details.routes').then((m) => m.personalDetailsRoutes),
    },
    {
        path: 'settings',
        loadChildren: () => import('./settings/settings.routes').then((m) => m.settingsRoutes),
    },
    {
        path: 'timemanagement',
        loadChildren: () => import('./time-management/time-management-routes').then((m) => m.timeManagementRoutes),
    },
    {
        path: 'timelimit',
        loadChildren: () => import('./interceptors/sweden-time-limit/sweden-timelimit-routes').then((m) => m.swedenTimeLimitInterceptorRoutes),
    },
    {
        path: 'cashback',
        loadChildren: () => import('./cashback/cashback.routes').then((m) => m.cashbackRoutes),
    },
    {
        path: 'rakeback',
        loadChildren: () => import('./cashback/cashback.routes').then((m) => m.cashbackRoutes),
    },
    {
        path: 'bonushistory',
        loadChildren: () => import('./bonus-history/bonus-history-routes').then((m) => m.bonusHistoryRoutes),
    },
    {
        path: 'history',
        loadChildren: () => import('./bonus-history/bonus-history-routes').then((m) => m.bonusHistoryRoutes),
    },
    {
        path: 'recovery',
        loadChildren: () => import('./account-recovery/account-recovery-routes').then((m) => m.accountRecoveryRoutes),
    },
    {
        path: 'changepassword',
        loadChildren: () => import('./change-password/change-password-routes').then((m) => m.changePasswordRoutes),
    },
    {
        path: 'changepin',
        loadChildren: () => import('./change-pin/change-pin-routes').then((m) => m.changePinRoutes),
    },
    {
        path: 'strongauthenticationsetting',
        loadChildren: () => import('./strong-auth-settings/strong-auth-settings.routes').then((m) => m.strongAuthSettingsRoutes),
    },
    {
        path: 'limits',
        loadChildren: () => import('./spending-controls-base/spending-controls-routes').then((m) => m.spendingControlsRoutes),
    },
    {
        path: 'languageandtimezone',
        loadChildren: () => import('./language-timezone/language-timezone-routes').then((m) => m.languageTimezoneRoutes),
    },
    {
        path: 'communication',
        loadChildren: () => import('./communication/communication-routes').then((m) => m.communicationRoutes),
    },
    {
        path: 'usnjcommunication',
        loadChildren: () => import('./communication-usnj/communication-usnj-routes').then((m) => m.communicationUsnjRoutes),
    },
    {
        path: 'notifylogin',
        loadChildren: () => import('./login-notifications/login-notifications-routes').then((m) => m.loginNotificationsRoutes),
    },
    {
        path: 'unsubscribenotifylogin',
        loadChildren: () =>
            import('./login-notifications-unsubscribe/unsubscribe-login-notifications-routes').then((m) => m.loginNotificationsUnsubscribeRoutes),
    },
    {
        path: 'transactions',
        loadChildren: () => import('./transactions/transactions-routes').then((m) => m.transactionsRoutes),
    },
    {
        path: 'bonuslandingpage',
        loadChildren: () => import('./bonus-landing-page/bonus-landing-page.routes').then((m) => m.bonusLandingPageRoutes),
    },
    {
        path: 'balancebreakdown',
        loadChildren: () => import('./balance-breakdown/balance-breakdown.routes').then((m) => m.balanceBreakdownRoutes),
    },
    {
        path: 'serviceclosure',
        loadChildren: () => import('./service-closure/service-closure-routes').then((m) => m.serviceClosureRoutes),
    },
    {
        path: 'updatesqsa',
        loadChildren: () => import('./update-sqsa/update-sqsa-routes').then((m) => m.updateSqsaRoutes),
    },
    {
        path: 'selfexclusion',
        loadChildren: () => import('./self-exclusion/self-exclusion-routes').then((m) => m.selfExclusionRoutes),
    },
    {
        path: 'oasisexclusion',
        loadChildren: () => import('./oasis-exclusion/oasis-exclusion-routes').then((m) => m.oasisExclusionRoutes),
    },
    {
        path: 'upload',
        loadChildren: () => import('./doc-upload/doc-upload-routes').then((m) => m.uploadRoutes),
    },
    {
        path: 'securelogin',
        loadChildren: () => import('./secure-login/secure-login-routes').then((m) => m.secureLoginRoutes),
    },
    {
        path: 'promotions',
        loadChildren: () => import('./promotions/promotions-routes').then((m) => m.promotionsRoutes),
    },
    {
        path: 'loginhistory',
        loadChildren: () => import('./login-history/login-history-routes').then((m) => m.loginHistoryRoutes),
    },
    {
        path: 'bankaccount',
        loadChildren: () => import('./bank-account-registration/bank-account-registration.routes').then((m) => m.bankAccountRegistrationRoutes),
    },
    {
        path: 'winlosshistory',
        loadChildren: () => import('./win-loss-history/win-loss-history-routes').then((m) => m.winLossHistoryRoutes),
    },
    {
        path: 'waitperiod',
        loadChildren: () => import('./wait-period/wait-period.routes').then((m) => m.waitPeriodRoutes),
    },
    {
        path: 'accountverification',
        loadChildren: () => import('./account-verification/account-verification-routes').then((m) => m.accountVerificationRoutes),
    },
    {
        path: 'accountverificationcz',
        loadChildren: () => import('./account-verification-cz/account-verification-cz.routes').then((m) => m.accountVerificationCZRoutes),
    },
    {
        path: 'myaccount',
        loadChildren: () => import('./my-account/my-account-routes').then((m) => m.myAccountRoutes),
    },
    {
        path: 'bonuses',
        loadChildren: () => import('./bonuses/bonuses.routes').then((m) => m.bonusesRoutes),
    },
    {
        path: 'atis',
        loadChildren: () => import('./atis-integration/atis-integration-routes').then((m) => m.atisIntegrationRoutes),
    },
    {
        path: 'confirmpassword',
        loadChildren: () => import('./confirm-password/confirm-password.routes').then((m) => m.confirmPasswordRoutes),
    },
    {
        path: 'gamblingcontrols',
        loadChildren: () => import('./gambling-controls/gambling-controls-routes').then((m) => m.gamblingControlsRoutes),
    },
    {
        path: 'accountclosurecontrols',
        loadChildren: () => import('./account-closure-controls/account-closure-controls-routes').then((m) => m.accountClosureControlRoutes),
    },
    {
        path: 'accountclosure',
        loadChildren: () => import('./account-closure/account-closure-routes').then((m) => m.accountClosureRoutes),
    },
    {
        path: 'verifyemail',
        loadChildren: () => import('./verify-email/verify-email-routes').then((m) => m.verifyEmailRoutes),
    },
    {
        path: 'bratsignupoffer',
        loadChildren: () => import('./brat-signup-offer/brat-signup-offer-routes').then((m) => m.bratSignupOfferRoutes),
    },
    {
        path: 'bonusteaser',
        loadChildren: () => import('./bonus-teaser/bonus-teaser-routes').then((m) => m.bonusTeaserRoutes),
    },
    {
        path: 'clientpostlogin',
        loadChildren: () => import('./client-postlogin/client-postlogin-routes').then((m) => m.clientPostLoginRoutes),
    },
    {
        path: 'clientplppreview',
        loadChildren: () => import('./client-plp-preview/client-plp-preview-routes').then((m) => m.clientPlpPreviewRoutes),
    },
    {
        path: 'invitefriends',
        loadChildren: () => import('./invite-friends/invite-friends-routes').then((m) => m.inviteFriendsRoutes),
    },
    {
        path: 'invitefriendssignup',
        loadChildren: () => import('./invite-friends/invite-friends-signup/invite-friends-signup-routes').then((m) => m.inviteFriendsSignupRoutes),
    },
    {
        path: 'recaptcha',
        loadChildren: () => import('./interceptors/recaptcha/recaptcha.routes').then((m) => m.recaptchaRoutes),
    },
    {
        path: 'partialregistration',
        loadChildren: () => import('./partial-registration/partial-registration-routes').then((m) => m.partialRegistrationRoutes),
    },
    {
        path: 'wrappersettings',
        loadChildren: () => import('./wrapper-settings/wrapper-settings.routes').then((m) => m.wrapperSettingsRoutes),
    },
    {
        path: 'transfers',
        loadChildren: () => import('./player-transfers/transfers.routes').then((m) => m.transfersRoutes),
    },
    {
        path: 'licenseagreements',
        loadChildren: () => import('./license-agreements/license-agreements.routes').then((m) => m.licensesAgreementRoutes),
    },
    {
        path: 'licences',
        loadChildren: () => import('./licenses/licenses.routes').then((m) => m.licensesRoutes),
    },
    {
        path: 'logintimemanagement',
        loadChildren: () => import('./login-time-management/login-time-management-routes').then((m) => m.loginTimeManagementRoutes),
    },
    {
        path: 'ourpartners',
        loadChildren: () => import('./multi-accounting/multi-accounting-routes').then((m) => m.multiAccountingRoutes),
    },
    {
        path: 'quickregistration',
        loadChildren: () => import('./quick-registration/quick-registration-routes').then((m) => m.quickRegistrationRoutes),
    },
    {
        path: 'panicbutton',
        loadChildren: () => import('./panic-button/panic-button-routes').then((m) => m.panicButtonRoutes),
    },
    {
        path: 'initaccountupgrade',
        loadChildren: () => import('./initaccountupgrade/init-account-upgrade-routes').then((m) => m.initAccountUpgraderoutes),
    },
    {
        path: 'lcgfundsregulation',
        loadChildren: () => import('./lcg-funds-regulation/lcg-funds-regulation-routes').then((m) => m.lcgFundsRegulationRoutes),
    },
    {
        path: 'virtualcard',
        loadChildren: () => import('./virtual-card/virtual-card.routes').then((m) => m.virtualCardRoutes),
    },
    {
        path: 'upgradeaccount',
        loadChildren: () => import('./upgrade-account/upgrade-account-routes').then((m) => m.upgradeAccountRoutes),
    },
    {
        path: 'winlossstatement',
        loadChildren: () => import('./win-loss-statement/win-loss-statement-routes').then((m) => m.winLossStatementRoutes),
    },
    {
        path: 'sports',
        loadChildren: () => import('./usnj-sports/usnj-sports-routes').then((m) => m.usnjSportsRoutes),
    },
    {
        path: 'fastregistrationdetails',
        loadChildren: () => import('./fastregistration-additionaldetails/fastregistration.routes').then((m) => m.fastRegistrationRoutes),
    },
    {
        path: 'vip',
        loadChildren: () => import('./vip/vip-routes').then((m) => m.vipRoutes),
    },
    {
        path: 'rewards',
        loadChildren: () => import('./vip-club/vip-club-routes').then((m) => m.vipClubRoutes),
    },
    {
        path: 'contactverification',
        loadChildren: () => import('./boris-account-verification/boris-account-verification-routes').then((m) => m.borisAccountVerificationRoutes),
    },
    {
        path: 'loyalty',
        loadChildren: () => import('./usnj-loyalty/usnj-loyalty-routes').then((m) => m.usnjLoyaltyRoutes),
    },
    {
        path: 'cblogin',
        loadChildren: () => import('./cb-login/cb-login-routes').then((m) => m.cbLoginRoutes),
    },
    {
        path: 'partnerlogin',
        loadChildren: () => import('./pmu-login/pmu-login-routes').then((m) => m.pmuLoginRoutes),
    },
    {
        path: 'pmulogin',
        loadChildren: () => import('./pmu-login/pmu-login-routes').then((m) => m.pmuLoginRoutes),
    },
    {
        path: 'profitloss',
        loadChildren: () => import('./profit-loss/profit-loss.routes').then((m) => m.profitLossRoutes),
    },
    {
        path: 'rglimitshistory',
        loadChildren: () => import('./rg-limits-history/rg-limits-history.routes').then((m) => m.rgLimitsHistoryRoutes),
    },
    {
        path: 'loginrestrictions',
        loadChildren: () => import('./interceptors/login-restrictions/login-restrictions-routes').then((m) => m.loginRestrictionsRoutes),
    },
    {
        path: 'nlverification',
        loadChildren: () => import('./nl-verification/nl-verification.routes').then((m) => m.nlverificationRoutes),
    },
    {
        path: 'authenticatorHomePage',
        loadChildren: () => import('./authenticator-app-home-page/authenticator-app-home-page-routes').then((m) => m.AuthenticatorRoutes),
    },
    {
        path: 'stakelimits',
        loadChildren: () => import('./stake-limits/stake-limits-routes').then((m) => m.StakeLimitsRoutes),
    },
    {
        path: 'kycauthentication',
        loadChildren: () => import('./kyc-authentication/kyc-authentication-routes').then((m) => m.KycAuthenticationRoutes),
    },
    {
        path: 'kycauthenticationv2',
        loadChildren: () => import('./kyc-authentication/kyc-authentication-v2-routes').then((m) => m.KycAuthenticationV2Routes),
    },
    {
        path: 'losslimits',
        loadChildren: () => import('./loss-limits/loss-limits-routes').then((m) => m.lossLimitsRoutes),
    },
    {
        path: 'otherstakelimits',
        loadChildren: () => import('./other-stake-limits/other-stake-limits-routes').then((m) => m.otherStakeLimitsRoutes),
    },
    {
        path: 'cookiesettings',
        loadChildren: () => import('./cookie-settings/cookie-settings-routes').then((m) => m.cookieSettingsRoutes),
    },
    {
        path: 'pokersessionlimits',
        loadChildren: () => import('./poker-session-limits/poker-session-limits-routes').then((m) => m.pokerSessionLimitsRoutes),
    },
    {
        path: 'sessionlimits',
        loadChildren: () => import('./session-limit-v2/session-limit-v2.routes').then((m) => m.sessionLimitsV2Routes),
    },
    {
        path: 'appsmigration',
        loadChildren: () => import('./apps-migration/apps-migration.routes').then((m) => m.appsMigrationRoutes),
    },
    {
        path: 'responsiblegaming',
        loadChildren: () => import('./responsible-gaming-public/responsible-gaming-public.routes').then((m) => m.responsibleGamingPublicRoutes),
    },
    {
        path: 'kycfullauthentication',
        loadChildren: () => import('./interceptors/kycfullauthentication/kycfullauthentication-routes').then((m) => m.KycFullAuthenticationRoutes),
    },
    {
        path: 'selfie',
        loadChildren: () => import('./interceptors/selfie/selfie-routes').then((m) => m.SelfieRoutes),
        data: routeData({ authorized: true }),
    },
    {
        path: 'nevadaPreReg',
        loadChildren: () => import('./interceptors/nevada-pre-reg-screen/nevada-pre-reg-screen-routes').then((m) => m.PreRegScreenRoutes),
    },
    {
        path: 'playbreak',
        loadChildren: () => import('./play-break/play-break-routes').then((m) => m.playBreakRoutes),
    },
    {
        path: 'selfassessment',
        loadChildren: () => import('./self-assessment/self-assessment.routes').then((m) => m.selfAssessmentRoutes),
    },
    {
        path: 'timespent',
        loadChildren: () => import('./time-spent/time-spent-routes').then((m) => m.timeSpentRoutes),
    },
    {
        path: 'chathistory',
        loadChildren: () => import('./chat-history/chat-history-routes').then((m) => m.ChatHistoryRoutes),
    },
    {
        path: 'guide',
        loadChildren: () => import('./zendesk-hcc-guide/guide.routes').then((m) => m.GuideRoutes),
    },
    {
        path: 'w2gtaxform',
        loadChildren: () => import('./w2g-digital-paper/w2g-tax-form.routes').then((m) => m.w2gTaxFormRoutes),
    },
    {
        path: 'uploaddocuments',
        loadChildren: () => import('./manual-doc-upload-revamp/manual-doc-upload-revamp.routes').then((m) => m.manualDocUploadRevampRoutes),
    },
    // //TEMP ONES
    {
        path: 'mohcu',
        loadChildren: () => import('./interceptors/markers-of-harm/markers-of-harm-routes').then((m) => m.markersOfHarmRoutes),
    },
    {
        path: 'payoutsettings',
        loadChildren: () => import('./payout-settings-page/payout-setting-page.routes').then((m) => m.PayoutSettingsPageRoutes),
    },
    {
        path: 'withdrawblocker',
        loadChildren: () => import('./withdraw-blocker/withdraw-blocker-routes').then((m) => m.withdrawBlockerRoutes),
    },
    {
        path: 'spendingcontrols',
        loadChildren: () => import('./spending-controls-base/spending-controls-routes').then((m) => m.spendingControlsRoutes),
    },
    {
        path: 'closureandreopening',
        loadChildren: () =>
            import('./account-closure-and-reopening/account-closure-and-reopening-routes').then((m) => m.accountClosureAndReopeningRoutes),
    },
    {
        path: 'timemanagementcontrols',
        loadChildren: () => import('./time-management-controls/time-management-controls-routes').then((m) => m.timeManagementControlRoutes),
    },
    {
        path: 'oAuth',
        loadChildren: () => import('./oauth/oauth-routes').then((m) => m.OauthRoutes),
    },
    {
        path: 'twentyfourhourabstention',
        loadChildren: () => import('./twenty-four-hour-abstention/twenty-four-hour-abstention-routes').then((m) => m.TwentyFourHourAbstentionRoutes),
    },
    {
        path: 'loyaltystore',
        loadChildren: () => import('./loyalty-store/loyalty-store.routes').then((m) => m.loyaltyStoreRoutes),
    },
    {
        path: 'budgetcalculator',
        loadChildren: () => import('./budget-calculator/budget-calculator-routes').then((m) => m.budgetCalculatorRoutes),
    },
    {
        path: 'ptkyc',
        loadChildren: () => import('./interceptors/portuguese-kyc/pt-kyc-routes').then((m) => m.ptKycRoutes),
    },
    {
        path: 'mxkyc',
        loadChildren: () => import('./interceptors/mx-kyc/mx-kyc-routes').then((m) => m.mxKycRoutes),
    },
    {
        path: 'plkyc',
        loadChildren: () => import('./interceptors/pl-kyc/pl-kyc-routes').then((m) => m.plKycRoutes),
    },
    {
        path: 'plverification',
        loadChildren: () => import('./interceptors/pl-kyc-verification/pl-kyc-verification-routes').then((m) => m.plKycverificationRoutes),
    },
    {
        path: 'depositlimitsnotice',
        loadChildren: () => import('./interceptors/be-limit-active/be-limit-active-routes').then((m) => m.beLimitRoutes),
    },
    {
        path: 'depositnplay',
        loadChildren: () => import('./deposit-and-play/deposit-and-play-routes').then((m) => m.depositAndPlayRoutes),
    },
    {
        path: 'personaldetailsreview',
        loadChildren: () => import('./interceptors/de-personal-details-review/de-personal-details.routes').then((m) => m.personalDetailsReviewRoutes),
    },
    {
        path: 'nlkyc',
        loadChildren: () => import('./interceptors/verify-id/verify-id-details.routes').then((m) => m.verifyIDRoutes),
    },
    {
        path: 'valueperception',
        loadChildren: () => import('./value-perception/value-perception-routes').then((m) => m.valuePerceptionRoutes),
    },
    {
        path: 'userdetails',
        loadChildren: () => import('./interceptors/user-details/user-details-routes').then((m) => m.userDetailsRoutes),
    },
    {
        path: 'kycrefresh',
        loadChildren: () => import('./interceptors/user-details/user-details-routes').then((m) => m.userDetailsRoutes),
    },
    {
        path: 'deschufa',
        loadChildren: () => import('./de-new-payment/new-payment.routes').then((m) => m.newPaymentRoutes),
    },
    {
        path: 'suggestionDepositLimits',
        loadChildren: () => import('./interceptors/suggestion-deposit-limits/suggestion-limits.routes').then((m) => m.suggestionLimitsRoutes),
    },
    {
        path: 'centrallimits',
        loadChildren: () => import('./interceptors/central-limits/central-limits.routes').then((m) => m.CentralLimitsRoutes),
    },
    {
        path: 'desportslimit',
        loadChildren: () =>
            import('./interceptors/sports-monthly-deposit-limit/sports-monthly-deposit-limit.routes').then((m) => m.DeSportsLimitsRoutes),
    },
    {
        path: 'documents',
        loadChildren: () => import('./documents/doucments-routes').then((m) => m.documentRoutes),
    },
    {
        path: 'sessionstatistics',
        loadChildren: () => import('./session-statistics/session-statistics-routes').then((m) => m.sessionStatisticsRoutes),
    },
    {
        path: 'languagepreferences',
        loadChildren: () => import('./language-preferences/language-preferences-routes').then((m) => m.languagePreferencesRoutes),
    },
    {
        path: 'migration',
        loadChildren: () => import('./interceptors/sasw/sasw-routes').then((m) => m.saswRoutes),
    },
    {
        path: 'monthlyoverview',
        loadChildren: () => import('./spain-monthly-overview/monthly-overview-routes').then((m) => m.monthlyOverViewRoutes),
    },
    {
        path: 'verifydob',
        loadChildren: () => import('./interceptors/dob-verification/dob-verification.routes').then((m) => m.dobVeriyRoutes),
    },
    {
        path: 'svoclosslimit',
        loadChildren: () => import('./interceptors/arc-svoc-level-four/arc-svoc-level-four-routes').then((m) => m.arcRoutes),
    },
    {
        path: 'sessionlimitsreminder',
        loadChildren: () =>
            import('./interceptors/session-limit-remainder-interceptor/session-limits-remainder.routes').then((m) => m.SessionLimitsRemainderRoutes),
    },
    {
        path: 'occupation',
        loadChildren: () => import('./occupation-details/occupation-details.routes').then((m) => m.OccupationDetailsRoutes),
    },
    {
        path: 'eskyc',
        loadChildren: () => import('./es-kyc/es-kyc.routes').then((m) => m.esKycRoutes),
    },
    {
        path: 'kyx',
        loadChildren: () => import('./kyx/id-facemap-routes').then((m) => m.kyxRoutes),
    },
    {
        path: 'addressinfo',
        loadChildren: () => import('./fastregistration-additionaldetails/fastregistration.routes').then((m) => m.personalDataRoutes),
    },
    {
        path: 'verifycontactdetails',
        loadChildren: () => import('./interceptors/mobile-verification/mobile-verification-routes').then((m) => m.MobileNumeberRoutes),
    },
    {
        path: 'verifyemailid',
        loadChildren: () => import('./contact-verification/email-verification/email-verification-routes').then((m) => m.EmailVerificationRoutes),
    },
    {
        path: 'verifymobile',
        loadChildren: () => import('./contact-verification/mobile-verification/mobile-verification.routes').then((m) => m.MobileNumeberVerification),
    },

    {
        path: 'verifyfacial',
        loadChildren: () =>
            import('./facial-mobile-email-verification/facial-email-mobile-verification-routes').then((m) => m.FacialEmailMobileRoutes),
    },
    {
        path: 'registerbankaccount',
        loadChildren: () =>
            import('./interceptors/bank-account-registration/bank-account-registration.routes').then((m) => m.bankAccountRegistrationRoutes),
    },
    {
        path: 'commspreference',
        loadChildren: () => import('./interceptors/comms-preferences/comms-preference.routes').then((m) => m.commspreferenceroutes),
    },
    {
        path: 'genderrace',
        loadChildren: () => import('./interceptors/gender-race/gender-race.routes').then((m) => m.genderraceroutes),
    },
    {
        path: 'depositlimitsconsent',
        loadChildren: () => import('./interceptors/deposit-limits-consent/deposit-limits-consent.routes').then((m) => m.depositLimitsConsentRoutes),
    },
    //TEMP ONES
    {
        path: 'emailorotp',
        redirectTo: 'recovery/emailorotp',
    },
    {
        path: 'securityquestion',
        redirectTo: 'recovery/securityquestion',
    },
    {
        path: 'verifyotp',
        redirectTo: 'recovery/verifyotp',
    },
    {
        path: 'resetpassword',
        redirectTo: 'recovery/resetpassword',
    },
    {
        path: 'lostpassword',
        redirectTo: 'recovery/lostpassword',
    },
    {
        path: 'verifyuserdetails',
        redirectTo: 'recovery/verifyuserdetails',
    },
    {
        path: 'premiummigrationstepone',
        redirectTo: 'premiummigration/stepone',
    },
    {
        path: 'transactionslegacy',
        redirectTo: 'transactions/legacy',
    },
    {
        path: 'premiummigrationsteptwo',
        redirectTo: 'premiummigration/steptwo',
    },
    {
        path: 'premiummigrationinformation',
        redirectTo: 'premiummigration/information',
    },
    {
        path: 'termsandconditions',
        redirectTo: 'tnc/termsandconditions',
    },
    {
        path: 'tncandintendedgamingactivity',
        redirectTo: 'tnc/tncandintendedgamingactivity',
    },
    {
        path: 'termsandconditionscnp',
        redirectTo: 'tnc/termsandconditionscnp',
    },
    {
        path: 'tncdownload',
        redirectTo: 'tnc/tncdownload',
    },
    {
        path: 'tnchistory',
        redirectTo: 'tnc/tnchistory',
    },
    {
        path: 'rglimitsconfirmation',
        redirectTo: 'rg/rglimitsconfirmation',
    },
    {
        path: 'rglimits',
        redirectTo: 'rg/rglimits',
    },
    {
        path: 'registerwithpaypal',
        redirectTo: 'paypal/registerwithpaypal',
    },
    {
        path: 'registerwithpaypalinfo',
        redirectTo: 'paypal/registerwithpaypalinfo',
    },
    {
        path: 'accountlimits',
        redirectTo: 'bankaccount/accountlimits',
    },
    {
        path: 'accountlimitsinfo',
        redirectTo: 'bankaccount/accountlimitsinfo',
    },
    {
        path: 'bankaccountregistration',
        redirectTo: 'bankaccount/bankaccountregistration',
    },
    {
        path: 'docupload',
        redirectTo: 'upload/docupload',
    },
    {
        path: 'documentupload',
        redirectTo: 'upload/documentupload',
    },
    {
        path: 'depositlimits',
        redirectTo: 'limits/depositlimits',
    },
    {
        path: 'spendinglimits',
        redirectTo: 'limits/spendinglimits',
    },
    {
        path: 'depositlimit',
        redirectTo: 'limits/depositlimit',
    },
    {
        path: 'disable2fa',
        redirectTo: 'twofa/disable2fa',
    },
    {
        path: 'security',
        redirectTo: 'twofa/security',
    },
    {
        path: 'twofa/:isUpdateOnline',
        redirectTo: 'twofa/twofa/:isUpdateOnline',
    },
    {
        path: '2fa/:isFromSettings',
        redirectTo: 'twofa/2fa/:isFromSettings',
    },
    {
        path: 'clientplppreview/:singlePromoId',
        redirectTo: 'clientplppreview/clientplppreview/:singlePromoId',
    },
    {
        path: 'maxstakelimits',
        redirectTo: 'spendingcontrols/maxstakelimits',
    },
    {
        path: 'depositcurfew',
        redirectTo: 'spendingcontrols/depositcurfew',
    },
    {
        path: 'maxlosslimit',
        redirectTo: 'spendingcontrols/maxlosslimit',
    },
    {
        path: 'limits/depositlimits',
        redirectTo: 'spendingcontrols/depositlimits',
    },
    {
        path: 'maxcreditlimit',
        redirectTo: 'spendingcontrols/maxcreditlimit',
    },
    {
        path: 'documentuploader',
        redirectTo: 'affordability/documentuploader',
    },
    {
        path: 'tac',
        redirectTo: 'migration/tac',
    },
    {
        path: 'statuscheck',
        redirectTo: 'migration/statuscheck',
    },
    {
        path: 'mybonuses',
        redirectTo: 'bonuses',
    },
];

export const MY_ACCOUNT_ROUTES: Routes = [
    {
        path: '',
        providers: [TagManagerRendererService],
        canMatch: [myaccountProductActivateGuard],
        canDeactivate: [myaccountProductDeactivateGuard],
        children: [...INTERNAL_MY_ACCOUNT_ROUTES],
    },
];
